<template>
<div class="d-flex justify-content-end align-items-center">
    <router-link :to="'/tickets/'+row.id+'/comments'" class="btn btn-sm btn-clean btn-icon btn-icon-sm">
	    <i class="fa fa-eye"></i>
    </router-link>
    <FeedbackColumn
        ref="descriptionColumn"
        @buttonClicked="FeedbackColumn"
        :row="row"
        :index="index"
        :datatable="datatable">
    </FeedbackColumn>
</div>
</template>

<script>
import $ from 'jquery'
import Vue from 'vue'
import FeedbackColumn from "./feedback-column.vue";


export default Vue.extend({
    components: {FeedbackColumn},
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    },
    computed: {
        selector() {
            return $('tr[data-row="'+this.index+'"')
        },
    },
    methods : {
        FeedbackColumn() {
            this.$refs.descriptionColumn.appendDataToModal();
        },
    },
})
</script>